// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailM":"M_d2xDetailM__7c__E"};